import { mockBuilder } from '../../utils/builderHelper.es.js';
import '../../enums/CoverSongOptionsEnum.es.js';
import { Trend } from './Trend.es.js';

/** @module Mocks */ /** typedoc */
function aTrend() {
    return mockBuilder(new Trend()).withDate('valid date').withDownloads(10).withStreams(200);
}

export { aTrend };
